import React from 'react';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { ServiceDeskAnalyticsContext } from '@atlassian/jira-servicedesk-analytics/src/ui/servicedesk-analytics-context/index.tsx';
import { lazyAfterPaint } from '@atlassian/react-loosely-lazy';
import type { ProjectBuilderProps, ProjectBuilder as ProjectBuilderDrawer } from './ui/index.tsx';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
export const LazyComponent = lazyAfterPaint<typeof ProjectBuilderDrawer>(
	() => import(/* webpackChunkName: "async-project-builder" */ './ui'),
	{ ssr: false },
);

export const AsyncProjectBuilderDrawer = (
	props: Partial<ProjectBuilderProps>,
): React.JSX.Element => (
	<JSErrorBoundary
		id="bundle-async-project-builder"
		packageName="jira-servicedesk-project-builder"
		fallback="flag"
	>
		<Placeholder fallback={null} name="jsm-project-builder">
			<ServiceDeskAnalyticsContext>
				<LazyComponent isOpenInitial={!!props.isOpenInitial} {...props} />
			</ServiceDeskAnalyticsContext>
		</Placeholder>
	</JSErrorBoundary>
);

export const canUseProjectBuilder = (isAdmin: boolean): boolean => isAdmin;
